module.exports = __webpack_public_path__ + "img/remind.fa32cfcb.png";